import { Handle, Position } from "reactflow";
import { Table2 } from "lucide-react";
import { SENSITIVITY_DOT } from "@/lib/semantics";
import { SEMANTICS } from "@/constants/testIds";

export function TableNode({ data }) {
  const { node, selected } = data;
  const dot = SENSITIVITY_DOT[node.sensitivity] || "bg-muted-foreground";
  return (
    <div
      data-testid={SEMANTICS.node}
      className={`w-[190px] rounded-lg border bg-card/95 font-mono shadow-sm transition-colors ${
        selected ? "border-accent ring-2 ring-accent/40" : "border-border/70 hover:border-accent/50"
      }`}
    >
      <Handle type="target" position={Position.Left} className="!h-2 !w-2 !border-0 !bg-accent" />
      <Handle type="source" position={Position.Right} className="!h-2 !w-2 !border-0 !bg-primary" />
      <div className="flex items-center justify-between rounded-t-lg border-b border-border/50 bg-muted/40 px-2.5 py-1">
        <span className="truncate text-[9px] uppercase tracking-[0.16em] text-muted-foreground">
          {node.schema}
        </span>
        <span className={`h-1.5 w-1.5 rounded-full ${dot}`} title={node.sensitivity || ""} />
      </div>
      <div className="px-2.5 py-2">
        <div className="flex items-center gap-1.5">
          <Table2 className="h-3.5 w-3.5 shrink-0 text-accent" />
          <span className="truncate text-xs font-semibold text-foreground">{node.table}</span>
        </div>
        <div className="mt-1.5 space-y-0.5">
          {node.columns.slice(0, 3).map((c) => (
            <div key={c.name} className="truncate text-[10px] text-muted-foreground">
              {c.name}
            </div>
          ))}
          {node.columns.length > 3 && (
            <div className="text-[10px] text-muted-foreground/70">
              +{node.columns.length - 3} more
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
